(() => {
  const root = document.querySelector('.fvpd-2149-reference');
  if (!root || root.dataset.ready === 'hydrangea-reference-v1') return;
  root.dataset.ready = 'hydrangea-reference-v1';

  let variants = [];
  try {
    variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
  } catch (error) {
    console.error('Hydrangea variant data could not be read.', error);
    return;
  }

  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: root.dataset.currency || 'USD'
  }).format(Number(cents || 0) / 100);
  const slides = [...root.querySelectorAll('[data-gallery-slide]')];
  const galleryButtons = [...root.querySelectorAll('[data-gallery-button]')];
  const colorButtons = [...root.querySelectorAll('[data-color-choice]')];
  const bundleButtons = [...root.querySelectorAll('[data-bundle-option]')];
  const variantInput = root.querySelector('[data-variant-id]');
  const addButton = root.querySelector('[data-add-button]');
  let galleryIndex = Math.max(0, slides.findIndex(slide => slide.classList.contains('fvpd-is-active')));
  let selectedColor = colorButtons.find(button => button.classList.contains('fvpd-is-active'))?.dataset.colorChoice || colorButtons[0]?.dataset.colorChoice;
  let selectedBundle = bundleButtons.find(button => button.classList.contains('fvpd-is-active'))?.dataset.bundleOption || bundleButtons[0]?.dataset.bundleOption;

  const hydrateSlide = slide => {
    const image = slide?.querySelector('img[data-fvpd-src]');
    if (!image) return;
    if (image.dataset.fvpdSrcset) image.srcset = image.dataset.fvpdSrcset;
    image.src = image.dataset.fvpdSrc;
    image.removeAttribute('data-fvpd-src');
    image.removeAttribute('data-fvpd-srcset');
  };
  const showSlide = index => {
    galleryIndex = Math.max(0, Math.min(slides.length - 1, index));
    hydrateSlide(slides[galleryIndex]);
    slides.forEach((slide, i) => slide.classList.toggle('fvpd-is-active', i === galleryIndex));
    galleryButtons.forEach((button, i) => {
      button.classList.toggle('fvpd-is-active', i === galleryIndex);
      button.setAttribute('aria-pressed', String(i === galleryIndex));
    });
    const current = root.querySelector('[data-gallery-current]');
    if (current) current.textContent = String(galleryIndex + 1);
  };
  const matchVariant = (color, bundle) => variants.find(variant =>
    variant.options?.[0] === color && variant.options?.[1] === bundle
  );
  const bundleLabel = count => `${count} ${count === 1 ? 'Bunch' : 'Bunches'}`;
  const putText = (selector, value) => root.querySelectorAll(selector).forEach(node => { node.textContent = value; });

  const refreshBundleCards = () => {
    const single = matchVariant(selectedColor, bundleButtons.find(button => Number(button.dataset.bundleCount) === 1)?.dataset.bundleOption);
    bundleButtons.forEach(button => {
      const variant = matchVariant(selectedColor, button.dataset.bundleOption);
      const count = Number(button.dataset.bundleCount || 1);
      const price = Number(variant?.price || 0);
      const savings = single ? Number(single.price) * count - price : 0;
      button.disabled = !variant?.available;
      button.querySelector('[data-bundle-card-price]').textContent = variant ? money(price) : 'Unavailable';
      button.querySelector('[data-bundle-card-unit]').textContent = variant
        ? `${money(Math.round(price / count))} per bunch${savings > 0 ? ` · Save ${money(savings)}` : ''}`
        : '';
    });
  };

  const updateSelection = ({ syncGallery = true, syncUrl = true } = {}) => {
    const variant = matchVariant(selectedColor, selectedBundle);
    if (!variant) return;
    const count = Number(bundleButtons.find(button => button.dataset.bundleOption === selectedBundle)?.dataset.bundleCount || 1);
    const label = bundleLabel(count);
    const price = money(variant.price);
    colorButtons.forEach(button => {
      const active = button.dataset.colorChoice === selectedColor;
      button.classList.toggle('fvpd-is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    bundleButtons.forEach(button => {
      const active = button.dataset.bundleOption === selectedBundle;
      button.classList.toggle('fvpd-is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    if (variantInput) {
      variantInput.value = String(variant.id);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    putText('[data-selected-variant-label],[data-selected-variant-summary]', selectedColor);
    putText('[data-selected-bundle-label],[data-selected-bundle-summary],[data-final-label],[data-sticky-label]', label);
    putText('[data-hero-price],[data-selected-price],[data-final-price]', price);
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? `Add ${label.toLowerCase()} — ${price}` : 'Sold out';
    }
    putText('[data-sticky-cta]', variant.available ? `Add ${label.toLowerCase()} — ${price}` : 'Sold out');
    refreshBundleCards();
    if (syncGallery) {
      const gallery = colorButtons.find(button => button.dataset.colorChoice === selectedColor)?.dataset.colorGalleryIndex;
      if (gallery !== undefined && gallery !== '') showSlide(Number(gallery));
    }
    if (syncUrl && window.location.protocol !== 'file:') {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  };

  galleryButtons.forEach((button, index) => button.addEventListener('click', () => {
    showSlide(index);
    const linkedColor = colorButtons.find(item => item.dataset.colorGalleryIndex === String(index));
    if (linkedColor) {
      selectedColor = linkedColor.dataset.colorChoice;
      updateSelection({ syncGallery: false });
    }
  }));
  colorButtons.forEach(button => button.addEventListener('click', () => {
    selectedColor = button.dataset.colorChoice;
    updateSelection();
  }));
  bundleButtons.forEach(button => button.addEventListener('click', () => {
    selectedBundle = button.dataset.bundleOption;
    updateSelection({ syncGallery: false });
  }));

  let pointerStart = null;
  const stage = root.querySelector('[data-gallery-stage]');
  stage?.addEventListener('pointerdown', event => { pointerStart = event.clientX; });
  stage?.addEventListener('pointerup', event => {
    if (pointerStart == null) return;
    const delta = event.clientX - pointerStart;
    pointerStart = null;
    if (Math.abs(delta) > 45) showSlide(galleryIndex + (delta < 0 ? 1 : -1));
  });
  const stickyAdd = root.querySelector('[data-sticky-add]');
  if (stickyAdd && addButton) stickyAdd.addEventListener('click', () => addButton.click());
  const sticky = root.querySelector('[data-sticky-buy]');
  const quickFacts = root.querySelector('.fvpd-facts');
  const updateSticky = () => {
    if (!sticky || !addButton || !quickFacts || window.innerWidth > 699) {
      sticky?.classList.remove('fvpd-sticky--visible');
      return;
    }
    const addBox = addButton.getBoundingClientRect();
    const factsBox = quickFacts.getBoundingClientRect();
    const addVisible = addBox.bottom > 0 && addBox.top < window.innerHeight;
    sticky.classList.toggle('fvpd-sticky--visible', factsBox.bottom < 0 && !addVisible);
  };
  window.addEventListener('scroll', () => requestAnimationFrame(updateSticky), { passive: true });
  window.addEventListener('resize', updateSticky);

  const requestedId = new URL(window.location.href).searchParams.get('variant');
  const initial = variants.find(variant => String(variant.id) === requestedId)
    || variants.find(variant => String(variant.id) === variantInput?.value);
  if (initial) {
    selectedColor = initial.options[0];
    selectedBundle = initial.options[1];
  }
  updateSelection({ syncUrl: false });
  updateSticky();
})();
